<template>
    <v-layout wrap>
        <v-flex xs12 class="d-flex align-center justify-space-between pb-0">
            <h2 class="text-h6">
                Carregamentos
                <span class="text-subtitle-2 grey--text">{{ sessionsCount }} em andamento · {{ historyCount }} finalizados</span>
                <span v-if="filteredCharges.length != charges.length" class="text-subtitle-2 grey--text"> · {{ filteredCharges.length }} de {{ charges.length }}</span>
            </h2>
            <div class="d-flex align-center">
                <span class="caption grey--text mr-1">Sessões</span>
                <RefreshTimer v-if="sessionsRefresh" v-bind="sessionsRefresh" class="mr-4" />
                <span class="caption grey--text mr-1">Histórico</span>
                <RefreshTimer v-if="historyRefresh" v-bind="historyRefresh" />
            </div>
        </v-flex>
        <v-flex xs12>
            <v-card outlined class="charge-table">
                <div class="charge-grid charge-header caption font-weight-bold text-uppercase">
                    <div class="text-center">Início</div>
                    <div class="text-center">Transação</div>
                    <div>Status</div>
                    <div>Carregador</div>
                    <div>Local</div>
                    <div class="text-center">Pagamento</div>
                    <div class="text-center">Energia</div>
                    <div class="text-center">Potência</div>
                    <div class="text-center">Carregando</div>
                    <div class="text-center">Conectado</div>
                    <div class="text-center">Bateria</div>
                    <div>Usuário</div>
                </div>
                <transition-group name="charge-list" tag="div" class="charge-table-body">
                    <ChargeRow v-for="item in filteredCharges" :key="item.key" :item="item" @open-payment="$emit('open-payment', $event)" />
                </transition-group>
                <div v-if="filteredCharges.length == 0" class="charge-table-empty text-center grey--text py-6">
                    {{ charges.length > 0 ? "Nenhum carregamento encontrado com os filtros" : "Nenhum carregamento no período" }}
                </div>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import RefreshTimer from "@/components/shared/RefreshTimer";

import ChargeRow from "./ChargeRow";
import { matchCharge } from "./shared/filters";

export default {
    name: "UnifiedArea",

    components: { ChargeRow, RefreshTimer },

    props: {
        charges: { type: Array, required: true },
        filters: { type: Object, required: true },
        sessionsRefresh: { type: Object, default: null },
        historyRefresh: { type: Object, default: null },
    },

    computed: {
        filteredCharges() {
            return this.charges.filter((item) => matchCharge(item, this.filters));
        },
        sessionsCount() {
            return this.filteredCharges.filter((item) => item.kind == "session").length;
        },
        historyCount() {
            return this.filteredCharges.filter((item) => item.kind == "history").length;
        },
    },
};
</script>

<style scoped>
.charge-header {
    border-bottom: 1px solid rgba(128, 128, 128, 0.4);
    border-left: 4px solid transparent;
    opacity: 0.8;
}

.charge-list-enter-active {
    transition: all 0.6s ease;
}

.charge-list-enter {
    opacity: 0;
    transform: translateY(-12px);
}

.charge-list-move {
    transition: transform 0.6s ease;
}
</style>
